import { render } from "./carPile.vue?vue&type=template&id=16caf37f&scoped=true"
import script from "./carPile.vue?vue&type=script&lang=js"
export * from "./carPile.vue?vue&type=script&lang=js"

import "./carPile.vue?vue&type=style&index=0&id=16caf37f&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16caf37f"]])

export default __exports__